import httpClient from '../utils/httpClient';

export default {
  async getCompanies() {
    const { data } = await httpClient.get('/api/companies');

    return data;
  }
};
